import * as React from 'react';

import { Translate } from 'react-localize-redux';

import { connect } from 'react-redux';
import styled from 'styled-components';
import { AnimatePresence } from 'framer-motion';
import { EarningsData } from '@webapp/types/ui/earnings/earnings';
import AppState from '@webapp/store/state';

import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import { Option } from '@webapp/types/common/option';

import { GenericDropdownBuilder } from '@webapp/controllers/form/dropdown';
import { earningsReport } from '@webapp/store/earnings/selectors';
import Hint from '@components/basics/hint';
import { EarningsListCtrl } from '@webapp/controllers/artist/artist-billing/earnings/earnings-list';
import moment from 'moment';

const DropdownCtrl = GenericDropdownBuilder();
interface ArtistPayoutPageProps {
  className?: string;
}
interface StateProps {
  report: EarningsData[];
}

const mapStateToProps = (state: AppState): StateProps => ({
  report: earningsReport(state.earnings, 'ARTIST'),
});

const SORTINGYEAR: Option<string>[] = [{ label: 'All', value: 'All' }];

export const ArtistPayoutPage: React.FC<ArtistPayoutPageProps & StateProps> = (
  props
) => {
  const { report } = props;
  const [sortingYear, setSortingYear] =
    React.useState<Option<string>[]>(SORTINGYEAR);
  const [sorting, setSorting] = React.useState('All');

  React.useEffect(() => {
    const newValues: Record<string, Option<string>> = {};

    report.forEach((val) => {
      const year = moment(val.date).format('YYYY');
      if (!(year in newValues)) {
        return (newValues[year] = { label: year, value: year });
      }
    });

    setSortingYear(
      SORTINGYEAR.concat(
        Object.values(newValues).sort((a, b) => b.value.localeCompare(a.value))
      )
    );
  }, [report]);

  const handleChange = (key: string) => {
    setSorting(key);
  };
  const getReport = (key?: string) => {
    let temp = props.report;
    if (key !== 'All') {
      temp = report.filter((val) => {
        if (moment(val.date).format('YYYY') === key) {
          return true;
        } else {
          return false;
        }
      });
    }
    return temp;
  };

  return (
    <MotionOpacity className={props.className}>
      <PaymentWrapper>
        <FlexRow>
          <EmptyDiv>
            <Typography type="subheader" weight="400" className="mb-20">
              <Translate id="ARTIST_PROFILE.EARNING.HISTORY" />
            </Typography>
            <Typography
              customSize="12px"
              opacity="0.5"
              weight="400"
              className="mb-20"
            >
              <Translate id="ARTIST_PROFILE.EARNING.HISTORY.DESCRIPTION" />
            </Typography>
          </EmptyDiv>
          <StyledDropdownCtrl
            className="dropdown-dsps"
            isGrey
            title={sorting}
            options={sortingYear}
            onChange={(key: any) => handleChange(key)}
          />
        </FlexRow>
        <AnimatePresence>
          <MotionOpacity>
            {props.report.length ? (
              <Typography opacity=".5" className="mb-40"></Typography>
            ) : (
              <Hint
                className="mt-40"
                customTitle={
                  <Translate id="USER_PROFILE.WALLET.HISTORY.EMPTY.TITLE" />
                }
              >
                <Translate id="USER_PROFILE.WALLET.HISTORY.EMPTY.TEXT" />
              </Hint>
            )}
            <EarningsListCtrl earnings={getReport(sorting)} className="mb-10" />
          </MotionOpacity>
        </AnimatePresence>
      </PaymentWrapper>
    </MotionOpacity>
  );
};

export default connect(mapStateToProps)(ArtistPayoutPage);

const PaymentWrapper = styled.div``;

const EmptyDiv = styled.div``;
const FlexRow = styled.div`
  display: flex;
`;
const StyledDropdownCtrl = styled(DropdownCtrl).attrs(() => ({
  noMaxHeight: true,
  noScroll: true,
}))`
  width: 100px;
`;
